import React from 'react';
import './css/Idias.css';
import idlogo1 from '../assets/idlogo1.svg';
import idlogo2 from '../assets/idlogo2.svg';
import idlogo3 from '../assets/idlogo3.svg';
import idlogo4 from '../assets/idlogo4.svg';

const Idias = () => {
    const idiadata = [
        {
            Title: "CREATIVE IDIAS",
            logo: idlogo1,
            Description: "We create innovative and imaginative designs that push the boundaries of creativity."
        },
        {
            Title: "INNOVATIVE IDIAS",
            logo: idlogo2,
            Description: "We embrace innovation and stay ahead of the curve, bringing fresh ideas to every project."
        },
        {
            Title: "EXPERIENCED IDIAS",
            logo: idlogo3,
            Description: "Our team brings a wealth of experience and expertise to every project, ensuring excellence."
        },
        {
            Title: "PROFESSIONAL IDIAS",
            logo: idlogo4,
            Description: "We deliver professional and high-quality designs that meet the highest standards."
        }
    ]

    return (
        <section className='main-div2'>
            <div className='idias-main-div-content1'>
                {idiadata.map((item, index) => (
                    <div
                        key={index}
                        className='idias-main-div-content1-content1'
                        style={{
                            borderLeft: index === 0 &&'none',
                            // borderRight: index === 0 &&'none',
                            borderBottom: index === 0 &&'none'
                        }}
                    >
                        <div className='idias-logo'>
                            <img src={item.logo} alt={item.Title} />
                        </div>
                        <h2 className='idias-heading'>{item.Title}</h2>
                        <div className='idias-hover-content'>
                            <p>{item.Description}</p>
                            
                        </div>
                        <p className='mobile-description'>{item.Description}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Idias;
